import { render, staticRenderFns } from "./EmployeeMergeWorkbench.vue?vue&type=template&id=cf2fcf04&scoped=true&"
import script from "./EmployeeMergeWorkbench.vue?vue&type=script&lang=js&"
export * from "./EmployeeMergeWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeMergeWorkbench.vue?vue&type=style&index=0&id=cf2fcf04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2fcf04",
  null
  
)

export default component.exports